import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#533afd',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: '智栈管理后台',
  pwa: false,
  logo: '/logo.svg',
  iconfontUrl: '',
  token: {
    header: {
      heightLayoutHeader: 56,
      colorBgHeader: '#ffffff',
      colorHeaderTitle: '#182638',
    },
    sider: {
      colorMenuBackground: '#ffffff',
      colorTextMenuTitle: '#283548',
      colorTextMenu: '#5e6d82',
      colorTextMenuSelected: '#533afd',
      colorBgMenuItemSelected: 'rgba(83,58,253,0.08)',
      colorTextMenuItemHover: '#182638',
      colorBgMenuItemHover: 'rgba(83,58,253,0.05)',
    },
    pageContainer: {
      paddingBlockPageContainerContent: 16,
      paddingInlinePageContainerContent: 20,
    },
  },
};

export default Settings;
